import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    background: {
      default: '#0000000d'
    },
    primary: {
      main: '#7D0414',
    },
    secondary: {
      main: '#160F10',
    },
  },
});

export default theme;
